var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/_shared-key.js
// module id = 252
// module chunks = 48 49 50